import { useEffect, memo } from "react";
import servicesImage from "../assets/images/cycloptServices.png";
import { Box, Typography, Divider } from "@mui/material";
import theme from "../theme";
import { ThirdCheckbox, Input, Tooltip } from "#components";


export const ServiceCheckBox = ({ title, titleSx, price, priceUnit, selected, setSelected, disabled, tooltip }) => (
	disabled ? (
		<Tooltip title={tooltip}>
			<Box display="flex" alignItems="center">
				<ThirdCheckbox size="1.5rem" checked={selected && !disabled} disabled={disabled} onChange={() => setSelected(!selected)}/>
				<Typography sx={{ ...titleSx }}>
					{title}
				</Typography>
				<Typography sx={{ marginLeft: "0.2rem", fontSize: "small" }}>
					{` €${price} per ${priceUnit ? priceUnit : "month"}`}
				</Typography>
				<Typography sx={{ color: theme.palette.red.main, marginLeft: "0.2rem" }}>*</Typography>
			</Box>
		</Tooltip>
	) : (
		<Box display="flex" alignItems="center">
			<ThirdCheckbox size="1.5rem" checked={selected && !disabled} disabled={disabled} onChange={() => setSelected(!selected)}/>
			<Typography sx={{ ...titleSx }}>
				{title}
			</Typography>
			<Typography sx={{ marginLeft: "0.2rem", fontSize: "small" }}>
				{` €${price} per ${priceUnit ? priceUnit : "month"}`}
			</Typography>
			<Typography sx={{ color: theme.palette.red.main, marginLeft: "0.2rem" }}>*</Typography>
		</Box>
	)
);


export const FreeCheckBox = ({ title, titleSx, selected, setSelected }) => (
	<Box display="flex" alignItems="center">
		<ThirdCheckbox size="1.5rem" checked={selected} sx={{ color: "pink" }} onChange={() => setSelected(!selected)}/>
		<Typography sx={{ ...titleSx }}>
			{title}
		</Typography>
	</Box>
);

const ServicesComponent = ({
	valueOneOff,
	setTotalOneOff,
	tddReports,
	setTddReports,
	tddReportsSelected,
	setTddReportsSelected,
	nis2Reports,
	setNis2Reports,
	nis2ReportsSelected,
	setNis2ReportsSelected,
	nonmaintainabilityReports,
	setNonmaintainabilityReports,
	nonmaintainabilityReportsSelected,
	setNonmaintainabilityReportsSelected,
}) => { 
	useEffect(() => {
		if (tddReportsSelected || nis2ReportsSelected || nonmaintainabilityReportsSelected) {
			if (tddReportsSelected && tddReports === 0) {
				setTddReports(1);
			}

			if (nis2ReportsSelected && nis2Reports === 0) {
				setNis2Reports(1);
			}

			if (nonmaintainabilityReportsSelected && nonmaintainabilityReports === 0) {
				setNonmaintainabilityReports(1);
			}

			const safeTddReports = Number.isNaN(tddReports) ? 0 : tddReports;
			const safeNis2Reports = Number.isNaN(nis2Reports) ? 0 : nis2Reports;
			const safeNonmaintainabilityReports = Number.isNaN(nonmaintainabilityReports) ? 0 : nonmaintainabilityReports;

			const totalTdd = tddReportsSelected ? safeTddReports : 0;
			const totalNis2 = nis2ReportsSelected ? safeNis2Reports : 0;
			const totalNonmaintainability = nonmaintainabilityReportsSelected ? safeNonmaintainabilityReports : 0;

			setTotalOneOff((totalTdd + totalNis2 + totalNonmaintainability) * 500);
		} else {
			setTddReports(0);
			setNis2Reports(0);
			setNonmaintainabilityReports(0);
			setTotalOneOff(0);
		}
	}, [tddReports, nis2Reports, nis2ReportsSelected, tddReportsSelected, nonmaintainabilityReports, nonmaintainabilityReportsSelected]);

	return (
		<Box>
			<Box
				component="img"
				src={servicesImage}
				alt="Services"
				sx={{ height: "5rem", objectFit: "contain" }}
			/>
			<Typography sx={{ color: theme.palette.pink.main, fontStyle: "italic" }}>
            Please check which services you want to use:
			</Typography>
			<Typography sx={{ color: theme.palette.grey.silver, fontStyle: "italic" }}/>
			<ServiceCheckBox title="Technical Due Diligence" titleSx={{ fontWeight: "bold" }} price="500" priceUnit="report" selected={tddReportsSelected} setSelected={setTddReportsSelected}/>
			{tddReportsSelected && (
				<Box ml={4.5} sx={{ display: "flex", alignItems: "baseline", pb:"1rem", gap:"0.5rem" }}>
					<Typography fontWeight="bold"> Number of reports: </Typography>
					<Input id="companion-seats"
						type="number"
						variant="standard"
						value={tddReports === 0 ? 1 : tddReports}
						fullWidth={false}
						onChange={(event) => {
							const newValue = event.target.value;
							if (newValue < 1) {
								setTddReports(1);
							} else if (newValue > 100) {
								setTddReports(100);
							} else {
								setTddReports(Number.parseInt(event.target.value));}
						}
						} 
						InputProps={{ inputProps: {  min: 1, max: 100, style: { textAlign: "center", width: "3rem", height: "1rem" } } }}
					/>
				</Box>
			)}
			<ServiceCheckBox title="NIS2 Compliance Reports" titleSx={{ fontWeight: "bold" }} price="500" priceUnit="report" selected={nis2ReportsSelected} setSelected={setNis2ReportsSelected}/>
			{nis2ReportsSelected && (
				<Box ml={4.5} sx={{ display: "flex", alignItems: "baseline", pb:"1rem", gap:"0.5rem" }}>
					<Typography fontWeight="bold"> Number of reports: </Typography>
					<Input id="companion-seats"
						type="number"
						variant="standard"
						value={nis2Reports === 0 ? 1 : nis2Reports}
						fullWidth={false}
						onChange={(event) => {
							const newValue = event.target.value;
							if (newValue < 1) {
								setNis2Reports(1);
							} else if (newValue > 100) {
								setNis2Reports(100);
							} else {
								setNis2Reports(Number.parseInt(event.target.value));}
						}
						} 
						InputProps={{ inputProps: {  min: 1, max: 100, style: { textAlign: "center", width: "3rem", height: "1rem" } } }}
					/>
				</Box>
			)}
			<ServiceCheckBox title="Non-Maintainability Reports" titleSx={{ fontWeight: "bold" }} price="500" priceUnit="report" selected={nonmaintainabilityReportsSelected} setSelected={setNonmaintainabilityReportsSelected}/>
			{nonmaintainabilityReportsSelected && (
				<Box ml={4.5} sx={{ display: "flex", alignItems: "baseline", pb:"1rem", gap:"0.5rem" }}>
					<Typography fontWeight="bold"> Number of reports: </Typography>
					<Input id="companion-seats"
						type="number"
						variant="standard"
						value={nonmaintainabilityReports === 0 ? 1 : nonmaintainabilityReports}
						fullWidth={false}
						onChange={(event) => {
							const newValue = event.target.value;
							if (newValue < 1) {
								setNonmaintainabilityReports(1);
							} else if (newValue > 100) {
								setNonmaintainabilityReports(100);
							} else {
								setNonmaintainabilityReports(Number.parseInt(event.target.value));}
						}
						} 
						InputProps={{ inputProps: {  min: 1, max: 100, style: { textAlign: "center", width: "3rem", height: "1rem" } } }}
					/>
				</Box>
			)}
			<Divider sx={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}></Divider>
			<Box display="flex" alignItems="center" ml={5.5}>
				<Typography> {`€ ${valueOneOff} one-off`} </Typography>
				<Typography sx={{ color: theme.palette.red.main, marginLeft: "0.2rem" }}>*</Typography>
			</Box>
		</Box>
	);};

export default memo(ServicesComponent);
